import {AddressInfo} from '../../ok-core/address/address-info';
import {GalleryItem} from '../../ok-core/photo/gallery-item';

export class Company {
  id: string;
  idUser: string;
  idParent: string;
  entity: string;
  document: string;
  country: string;
  name: string;
  desc: string;
  fantasyName: string;
  addressInfo: AddressInfo;
  email: string;
  state: string;
  city: string;
  district: string;
  contact: string;
  phone: string;
  contactEmail: string;
  contactPhone: string;
  contactName: string;
  creationDate: Date;
  status: string;
  countPending: number;
  idCategory: string;
  nameCategory: string;
  info: any;
  fgFeatured: Boolean;
  colorImage: any;
  colorImage2: any;
  rating = 0;
  gallery: GalleryItem[];
  visible = 'ACTIVE';
  type: string;
  cnae: Cnae;
  secondaryCnaes: Cnae[];
  socialName: string;
  urlImage: string;
}

export class Reports {
  idCompany: string;
  name: string;
  id: string;
  titlePt: string;
  titleEn: string;
  descriptionPt: string;
  descriptionEn: string;
  creationDate: Date;
  status: string;
  gallery: any;
  colorImage: string; 
}

export class CompanyPage {
  idParent: string;
  page: number;
}

export class Cnae {
  id: string;
  cnae: string;
  desc: string;
  cnaeFormated: string;
}
